import {Extension} from 'tiptap'
import {InputRule, emDash} from 'prosemirror-inputrules'

export default class InputRules extends Extension {
  inputRules() {
    return [
      emDash,
      new InputRule(/-_$/, "–")
    ]
  }
}
